export default __webpack_public_path__ + "static/media/TimeImg.b7173e45.svg";